<!-- eslint-disable vue/no-template-shadow -->
<template>
    <section class="page-filters">
        <section class="header">Filtrar Empreendimentos</section>
        <section class="body scroll-color">
            <section class="filter-box">
                <div v-for="filter in data" :key="filter.id">
                    <div v-if="filter.filter != '0'">
                        <div class="title">
                            <div>{{filter.name}}</div>
                        </div>	
                        <div class="list">
                            <ul>
                                <li v-for="item in filter.items" :key="item.id">
                                    <ui-checkbox :id="item.id" :label="item.name" design="success xs" :checked="item.checked" @input="filters($event, item.id)"/>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </section>
        <section class="footer">
			
            <div>
                <ui-button type="submit" design="md line block" @click="clear()"> Limpar Filtros </ui-button>
            </div>
            <div>
                <ui-button type="submit" design="md primary block" @click="filter()"> Aplicar Filtros </ui-button>
            </div>
        </section>
    </section>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiCheckbox } from '@/components/ui/form'
	import { storage } from '@/services/storage'


	export default {
		name: "filter-product",
		components: { uiButton, uiCheckbox },
		props: {
			data: {
				type: [Object, Array],
				default: () => {}
			}
		},
		data() {
			return {
				itemChecked: [],
				listChecked: true,
				vizibleChecked: true,
				productsFiltreds: null,
			}
		},
		mounted () {
			/**
			 * traz os valores dos products dentro do local storage para adicionar
			 * os valores marcados
			 */
			let itensStorage = JSON.parse(storage.get('product_filter'))
			if (itensStorage) {
				let transform= Object.keys(itensStorage)
				transform.forEach( res => {
					this.itemChecked.push(JSON.parse(res))
				})	
			}
			//seta o checkbox marcado
			if (this.data) {
				this.data.forEach(result => {
					result.items.map(res => {
						this.$set(res, 'checked', false)
					})
				})
			}
    	},
		methods: {
			//seta os valores  e adiciona o valor de falso ou verdadeiro ao clicar no checkbox
			filters(event, value) {
				event && value ? this.itemChecked.push(value) : this.itemChecked.splice(this.itemChecked.indexOf(value), 1);
				this.data.forEach(result => {
					result.items.map(res => {
						if(res.id == value && (this.itemChecked.indexOf(value), 1)) {
							if(res.checked) {
								this.$set(res, 'checked', false)
							} else {
								this.$set(res, 'checked', true)
							}
						}
					})
				})
			},
			//manda um emit para o index para trazer os filtros
			filter(){
				if(this.itemChecked.length > 0) { 
					this.$emit('filter', this.itemChecked) 
				} else { 
					this.$emit('filter', null)
					storage.set('product_filter', null)
				}
			},
			//limpa todos os filtros
			clear() {
				this.itemChecked = []
				this.listChecked = false
				this.$emit('filter', null)
				storage.remove('product_filter')
				this.data.forEach(result => {
					result.items.map(res => {
						this.$set(res, 'checked', false)
					})
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import '~@/assets/styl/base.styl'
	.page-filters
		height 100%
		display flex
		flex-direction column
		background #FFF
		.header
			padding 16px 35px
			font-weight 600
			font-size 17px
			color primary-2
			border-bottom 1px #EAEAF6 solid
		.body
			flex 1
			overflow auto
			padding 15px 0
		.footer
			border-top 1px #EAEAF6 solid
			padding 12px 12px
			display flex
			div
				flex 1
				&:first-child
					padding-right 3px
				&:last-child
					padding-left 3px

	.filter-box
		.title
			padding 15px 35px 25px 35px
			display flex
			div
				&:first-child
					font-weight 500
					font-size 15px
					flex 1
				&:last-child
					button
						font-size 10px
						background transparent
						padding 0 5px
						border 0
						border-bottom 1px #EAEAF6 solid

		.list
			padding 0 35px 
			ul
				list-style none
				padding 0
				margin 0
				li
					padding 2px 0

</style>